import React, { Component } from 'react';
import Select from 'react-select-plus';
import { Icon } from '@mgc/react-components';
import PropTypes from 'prop-types';
import MapPropTypes from '../MapPropTypes';
import strings from '../../strings';
import './Selector.scss';

export default class ProductSelector extends Component {
    static propTypes = {
        offer: MapPropTypes.OfferProps,
        selectedProductIndex: PropTypes.number.isRequired,

        selectProduct: PropTypes.func.isRequired,
        addProductToCart: PropTypes.func.isRequired,
    };

    constructor() {
        super();
    }

    _handleButtonClick() {
        this.props.addProductToCart(this.props.selectedProductIndex);
        this.props.selectProduct(-1);
    }

    _handleProductSelect(option) {
        if (!option) {
            this.props.selectProduct(-1);
        } else {
            this.props.selectProduct(option.value);
        }
    }

    _renderOption(option) {
        return (
            <span>
                {option.product.name}
                <small className="text-mute"> #{option.product.mentorId}</small>
            </span>
        );
    }

    _getOptions() {
        if (!this.props.offer || !this.props.offer.pricing) {
            return [];
        }

        return this.props.offer.pricing.map((item, index) => ({
            label: `${item.product.name} #${item.product.mentorId}`,
            product: item.product,
            value: index,
        }));
    }

    _getSelectedOption() {
        if (this._isButtonDisabled()) {
            return -1;
        }

        return this.props.selectedProductIndex;
    }

    _isButtonDisabled() {
        return !this.props.offer || this.props.selectedProductIndex === -1;
    }

    render() {
        return (
            <div className="card raised-sm border-none product-selector">
                <div className="card-header card-header-success text-inverse">
                    <b>{strings.chooseAProduct}</b>
                </div>
                <div className="card-block">
                    <div className="input-group">
                        <div id="product-select" className="">
                            <Select
                                multi={false}
                                placeholder={strings.selectAProduct + '...'}
                                clearable={!this._isButtonDisabled()}
                                value={this._getSelectedOption()}
                                options={this._getOptions()}
                                onChange={(s) => this._handleProductSelect(s)}
                                valueRenderer={(o) => this._renderOption(o)}
                                optionRenderer={(o) => this._renderOption(o)}
                            />
                        </div>
                        <span className="input-group-btn">
                            <button
                                onClick={() => this._handleButtonClick()}
                                disabled={this._isButtonDisabled()}
                                className="btn btn-success btn-lg btn-block configure-button"
                            >
                                <Icon name="icon-cog3" />{' '}
                                {strings.configureThisProduct}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/OrderForm/Selector.jsx